import { useRef, useState } from "react";
import { Accordion, Col, Nav, Row, Table } from "react-bootstrap";
import "styles/page.css";
import SearchIcon from "assets/images/search.svg";
import DownIcon from "assets/images/downIcon.svg";
import RightIcon from "assets/images/rightIcon.svg";
import parse from "html-react-parser";
import statement from "assets/pdf/contact-us/Statement Request Form.pdf";
import complaint from "assets/pdf/contact-us/Complaint Form.pdf";
import transactiondispute from "assets/pdf/contact-us/Transaction_Dispute_Form.pdf";

import { accordionItems, branchLocation } from "constants/contact-us";
function ContactUs() {
  const [location, setLocation] = useState(branchLocation[0]);
  const [branchType, setBranchType] = useState("WITHIN");
  const [search, setSearch] = useState("");
  const divRef = useRef(null);
  const scrollToBottom = () => {
    if (divRef.current) {
      divRef.current.scrollTo({
        top: divRef.current.scrollHeight,
        behavior: "smooth", // This enables smooth scrolling
      });
    }
  };

  return (
    <div className="container page" id="contact-us">
      <div>
        <h1 className="p-0 mb-4">alrajhi bank Malaysia Branches</h1>
        <Nav
          variant="underline"
          className="d-flex justify-content-start py-5"
          style={{ color: "#000045" }}
        >
          <Nav.Link
            className={`nav-link ${branchType === `WITHIN` && `active`}`}
            onClick={() => setBranchType("WITHIN")}
          >
            Within Klang Valley
          </Nav.Link>
          <Nav.Link
            className={`nav-link ${branchType === `OUTSIDE` && `active`}`}
            onClick={() => setBranchType("OUTSIDE")}
          >
            Outside Klang Valley
          </Nav.Link>
          <Nav.Link
            className={`nav-link ${branchType === `ATM` && `active`}`}
            onClick={() => setBranchType("ATM")}
          >
            ATM Location
          </Nav.Link>
        </Nav>
        <Row>
          <Col md={4}>
            <div className="input-group input-group-lg mb-3">
              <input
                type="text"
                className="form-control"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <div
                className="input-group-text"
                style={{ backgroundColor: "white", height: "48px" }}
              >
                <img src={SearchIcon} alt="" style={{ margin: "2.5px"}}/>
              </div>
            </div>

            <div className="contact-map" ref={divRef}>
              {branchLocation
                .filter((branch) =>
                  search.length >= 3
                    ? branch.addreess
                        .toLowerCase()
                        .includes(search.toLowerCase())
                    : branch
                )
                .filter((branch) => branch.type === branchType)
                .map((branch) => {
                  return (
                    <div
                      className="branch d-flex flex-row justify-content-center"
                      style={{ height: "auto", textAlign: "left" }}
                      onClick={() => setLocation(branch)}
                      key={branch.name}
                    >
                      <div style={{ color: "#000045" }}>
                        <p style={{ fontWeight: 600 }}>{branch.name}</p>
                        <p style={{ fontSize: "14px" }}>{branch.addreess}</p>
                        <span style={{ fontSize: "14px" }}>
                          Phone no: {branch.phoneNo}
                        </span>
                      </div>
                      <div>
                        <img src={RightIcon} alt="" />
                      </div>
                    </div>
                  );
                })}
            </div>
            <div
              className="d-flex justify-content-center mt-2"
              onClick={scrollToBottom}
            >
              <img src={DownIcon} alt="" />
            </div>
          </Col>

          <Col md={8}>
            <iframe
              title="map"
              src={location.src}
              width="100%"
              height="100%"
              frameBorder="0"
              style={{ border: 0, height: "70vh", borderRadius: "15px" }}
              allowFullScreen
            ></iframe>
          </Col>
        </Row>

        <div style={{ height: "40px" }}> </div>

        <Row>
          <Col md={6}>
            <div className="info-card">
              <h1>
                24-Hour <span>Customer Care Consultants</span>
              </h1>
              <p>
                For more information on alrajhi bank Malaysia products and
                services, kindly contact one of our Customer Care Consultants
                using your preferred method below:
              </p>
              <ul>
                <li>+603 2332 6000</li>
                <li>
                  <a href="mailto:customersupport@alrajhibank.com.my">
                    customersupport@alrajhibank.com.my
                  </a>
                </li>
              </ul>

              <p>Retail Collection & Recovery Centre</p>
              <ul>
                <li>+603-20365200</li>
              </ul>

              <p>Note:</p>

              <ol>
                <li>
                  Please remember: Emails are not inherently secure. For
                  security reasons, please <b>refrain</b> from including{" "}
                  <b>personal or confidential information</b> when initiating an
                  email to alrajhi bank Malaysia. Should there be a need to
                  disclose your personal or confidential information, kindly
                  visit your nearest branch to do so or you may contact our
                  Customer Care Consultants at +603 2332 6000.
                </li>
                <li>
                  Neither alrajhi bank Malaysia, Bank Negara Malaysia (BNM),
                  PayNet nor any of its affliates will ever ask you for your{" "}
                  <b>personal or confidential information</b> e.g. account
                  information, alrajhi@24seven User ID, Passwords, One Time
                  Password (OTP) or Card PINs when contacting via call, text
                  message or email.
                </li>
              </ol>
            </div>

            <div style={{ height: "50px" }}> </div>
            <div className="info-card">
              <Table className="info-table  align-middle text-center">
                <thead>
                  <tr>
                    <th>States</th>
                    <th>Day</th>
                    <th>Revised Operating Hours</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowSpan={3}>
                      All States
                      <br />
                      (Except East Cost)
                    </td>
                    <td>Monday - Thursday</td>
                    <td>09.15 - 16.15</td>
                  </tr>
                  <tr>
                    <td>Friday</td>
                    <td>
                      09.15 - 16.15
                      <br />
                      Closed for Prayers
                      <br />
                      West Malaysia <br />
                      (12:30 PM - 14:30 PM) <br />
                      East Malaysia
                      <br />
                      (12:00 PM - 14:00 PM)
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td>Saturday, Sunday & Public Holiday</td>
                    <td>Closed</td>
                  </tr>
                  <tr>
                    <td rowSpan={2}>East Coast</td>
                    <td>Sunday - Thursday</td>
                    <td>09:15 - 16:15</td>
                  </tr>
                  <tr>
                    <td>Friday, Saturday & Public Holiday</td>
                    <td>Closed</td>
                  </tr>
                </tbody>
              </Table>
            </div>
            <div style={{ height: "50px" }}> </div>

            <div className="additional-info">
              <h1>Frequently Used Forms</h1>
              <a href={statement} target="blank">
                Statement Request Form
              </a>
              <br />
              <a href={complaint} target="blank">
                Complaint Form
              </a>
              <br />
              <a href={transactiondispute} target="blank">
                Transaction Dispute Form
              </a>
            </div>

            <div style={{ height: "30px" }}> </div>

            <div className="additional-info">
              <h1>Media Enquiries</h1>
              <h2>Corporate Affairs</h2>
              <a href="mailto:corporateaffairs@alrajhibank.com.my">
                corporateaffairs@alrajhibank.com.my
              </a>
            </div>
          </Col>
          <Col md={6}>
            <Accordion defaultActiveKey="0" flush>
              {accordionItems.map((item, index) => (
                <Accordion.Item eventKey={index}>
                  <div className="contact-us-accordion">
                    <Accordion.Header>{parse(item.title)}</Accordion.Header>
                    <Accordion.Body>{parse(item.content)}</Accordion.Body>
                  </div>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default ContactUs;
